export const ProfessionalWorkStatus = {
  RANKINGS: "Rankings",
  UPCOMING: "Upcoming",
  IN_PROGRESS: "In Progress",
  PAST: "Past",
  STARRED: "Starred",
};

export const DefaultATeamRosterSize = 5;

export const DEFAULT_TOAST_AUTO_HIDE_DURATION_IN_MILLISECONDS = 8000;

export const A_TEAM_COLOR = "#1890FF";
